import api from '@/api'
// get total data from Database
export default {
  getTotalInfluencers() {
    return new Promise(function(resolve, reject) {
      api
        .request('get', `/api/v1/influencers/total`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data.totalInfluencers)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getTotalClients() {
    return new Promise(function(resolve, reject) {
      api
        .request('get', `/api/v1/clients`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data.totalClients)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getTotalCompanies() {
    return new Promise(function(resolve, reject) {
      api
        .request('get', `/api/v1/companies`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data.totalCompanies)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getTotalCampaigns() {
    return new Promise(function(resolve, reject) {
      api
        .request('get', `/api/v1/campaigns`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data.totalCampaigns)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getAMCODashboardTotal() {
    return new Promise(function(resolve, reject) {
      api
        .request('get', `/api/v1/campaigns/amco-dashboard-total`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/views/DashboardComponents/KobeOverviewHelper.js